module.exports = function card() {
    return {
        data: function() {
            return {
                details: {
                    seen: false
                }
            }
        },
        props: ['rec'],
        template: require('./_card.html')
    };
};